import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';

/**
 * Shared shell for public browse (list + detail) pages.
 * No admin Sidebar - this is used on public-facing routes only.
 */
const PublicBrowseShell = ({ title, subtitle, actions, children }) => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="bg-green-100 border-b border-green-200 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-lg flex items-center justify-center shrink-0 overflow-hidden bg-transparent">
                <img
                  src="/tbf-logo-header.png"
                  alt="Tanzania Basketball Federation"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <p className="text-base md:text-lg font-bold text-primary leading-tight">Tanzania Basketball</p>
                <p className="text-xs text-muted-foreground leading-tight">Federation Portal</p>
              </div>
            </Link>
            <Link to="/">
              <Button variant="outline" size="sm" iconName="Home">
                Home
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        {(title || subtitle || actions) && (
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              {title && <h1 className="text-3xl font-bold text-foreground">{title}</h1>}
              {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
          </div>
        )}
        {children}
      </main>
    </div>
  );
};

export default PublicBrowseShell;
